import React from 'react';
import { Col } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { timeAgo } from '../../utils/mappers';
import useWindowSize from '../../hooks/useWindowSize'; // Crie um hook para obter o tamanho da tela
import "./styles.scss"
import { Link } from 'react-router-dom';
const CardNews = ({ newsItem }) => {
  const history = useHistory();
  const size = useWindowSize(); // Hook personalizado para pegar o tamanho da tela

  const handleCardClick = (event) => {
    if (event.target.closest('a')) {
      event.stopPropagation(); // Evita propagação quando o link for clicado
    } else {
      history.push(`/new/${newsItem.slug}`);
    }
  };

  return (
    <Col xs={12} sm={6} md={4} lg={4} xl={3} style={{ marginBottom: '30px' }}>
      <div
        onClick={handleCardClick}
        className="news-card-overlay"
        style={{ cursor: 'pointer', position: 'relative', borderRadius: '10px', overflow: 'hidden' }}
      >
        <img
          src={newsItem.image_url}
          alt={newsItem.name}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',

          }}
        />

        {/* CATEGORIA OU TAG */}
        {newsItem.categoryName && (
          <span className="badge badge-primary" style={{
            position: 'absolute',
            top: '10px',
            left: '10px',
            fontSize: '12px'
          }}>
            {newsItem.categoryName}
          </span>
        )}

        {/* SOBREPOSIÇÃO DE TEXTO */}
        <div className="news-overlay-text">
          <h5 className="overlay-title">{newsItem.name}</h5>
          <p className="overlay-footer">
            {new Date(newsItem.created_at).toLocaleDateString()} &nbsp;|&nbsp; {new Date(newsItem.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </p>
        </div>
      </div>
    </Col >

    /*{
    <Col xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginBottom: '30px' }}>
      <div
        onClick={handleCardClick}
        className={`news-card ${size.width > 768 ? 'd-flex align-items-center' : ''}`} // Aplica 'd-flex' apenas no desktop
        style={{ cursor: 'pointer', border: 'none', padding: '15px 8px', background: 'none' }}
      >
   
        <Col xs={12} md={4} lg={3} className="news-image">
          <img
            src={newsItem.image_url}
            alt={newsItem.name}
            style={{
              width: '100%',
              height: '100%',
              maxHeight: '250px',
              objectFit: 'cover',
              borderRadius: '10px',
              pointerEvents: 'none',
            }}
          />
        </Col>

        
        <Col xs={12} md={8} lg={9} className="d-flex flex-column justify-content-between news-content">
          <small
            className="text-muted news-footer"
            style={{
              marginBottom: '5px',
              userSelect: 'none',
              pointerEvents: 'none',
            }}
          >
            {timeAgo(newsItem.created_at)} - {new Date(newsItem.created_at).toLocaleDateString()}
          </small>

          <h5
            className="news-title"
            style={{
              fontWeight: 'bold',
              fontSize: '16px',
              marginBottom: '5px',
              lineHeight: '1.3',
              color: '#000',
              userSelect: 'none',
              pointerEvents: 'none',
            }}
          >
            {newsItem.name}
          </h5>

          <p
            className="news-text"
            style={{
              fontSize: '11px',
              color: '#555',
              marginBottom: '0',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              userSelect: 'none',
              pointerEvents: 'none',
            }}
          >
            {newsItem.subtitle}
          </p>
        </Col>
      </div>
    </Col> }*/
  );
};

export default CardNews;
